import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStreamEnvironment, ErmCapabilityApiClientService } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-launch-native',
  templateUrl: './launch-native.component.html',
  styleUrls: ['./launch-native.component.scss']
})
export class LaunchNativeComponent implements OnInit {

  env?: AppStreamEnvironment;
  streamingUrl?: string;
  applicationStreamingUrl?: string;
  fleetKind?: string;

  isWorking = false;
  isErmUnavailable = false;

  constructor(
    private route: ActivatedRoute,
    private ermCapabilityApiClient: ErmCapabilityApiClientService
  ) { }

  async ngOnInit(): Promise<void> {

    try {
      this.isWorking = true;

      // Get route parameters
      const params = this.route.snapshot.params;
      const launchEnvId = params['envId'];
      const streamingUrl = params['streamingUrl'];

      // Get route data
      const data = this.route.snapshot.data;
      this.fleetKind = data['fleetKind'];

      // Get environment
      const getAppStreamEnvironmentResponse = await this.ermCapabilityApiClient.getAppStreamEnvironment(launchEnvId);
      this.env = getAppStreamEnvironmentResponse.body?.appStreamEnvironment;

      // Launch streaming session
      const applicationStreamingUrl = `amazonappstream:${btoa(streamingUrl)}`;
      window.location.href = applicationStreamingUrl;

    } catch (error) {
      this.isErmUnavailable = true;
      throw error;
    }
    finally {
      this.isWorking = false;
    }
  }
}
